import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.png';
import LoginModal from '../LoginModal/LoginModal';
import './Header.css';

function Header() {
  const [user, setUser]           = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const navigate = useNavigate();

  const loadUser = () => {
    const stored = localStorage.getItem('ibots_user');
    setUser(stored ? JSON.parse(stored) : null);
  };

  useEffect(() => {
    loadUser();
    window.addEventListener('ibots_user_updated', loadUser);
    window.addEventListener('ibots_open_login', () => setShowLogin(true));
    return () => {
      window.removeEventListener('ibots_user_updated', loadUser);
      window.removeEventListener('ibots_open_login', () => setShowLogin(true));
    };
  }, []);

  const firstLetter = user ? user.name.charAt(0).toUpperCase() : '';

  return (
    <>
      <header className="header">
        <div className="header__logo">
          <img src={logo} alt="ibots logo" className="logo__img" />
        </div>

        <div className="header__right">
          {user ? (
            <div className="header__user-logged" onClick={() => navigate('/my-account')}>
              <div className="header__user-avatar">{firstLetter}</div>
              <div className="header__user-info">
                <span className="header__user-welcome">Welcome back</span>
                <span className="header__user-name">{user.name.split(' ')[0]}</span>
              </div>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5" style={{ marginLeft:2 }}>
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </div>
          ) : (
            <div className="header__login" onClick={() => setShowLogin(true)}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="#333" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              <span>Login / Register</span>
            </div>
          )}

          <div className="header__cart">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="#e53935" strokeWidth="2">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <path d="M16 10a4 4 0 0 1-8 0" />
            </svg>
            <span className="cart__price">₹0.00</span>
            <span className="cart__badge">2</span>
          </div>
        </div>
      </header>

      {showLogin && <LoginModal onClose={() => setShowLogin(false)} />}
    </>
  );
}

export default Header;